module.exports = __webpack_public_path__ + "files/131b8a841c933f200d2fe2555ad461ef.png";